import { useCallback, useEffect, useState } from "react"
import ListadoComprobantesWeb from "./ListadoComprobantesWeb"
import ConfirmDialog from "./../../../Dialogs/ConfirmDialog"
import Navbar from "../../../Navbar"
import {getData, getDataIx0, putData} from "../../../../services/library"
import { UrlApi } from "../../../../services/apirest"
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Typography } from "@mui/material"
import { getUserBranchesFilter } from "../../../../utils/filters"

function App() {
  const [comprobantes, setComprobantes] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isError] = useState(false)
  const [showConfirmacion, setShowConfirmacion]=useState({open:false});
  const [comprobanteAAnular, setComprobanteAAnular]=useState();
  const [sucursalesConsulta, setSucursalesConsulta] = useState();
  const [notify, setNotify]=useState();
  const [userSucData, setUserSucData]=useState();
  const sucs = getUserBranchesFilter();

  const loadData = useCallback((dataToUse) => {
    const currentData = dataToUse || userSucData?.id_alias; 

    if (!currentData) return;

    setIsLoading(true);
    const sucs = getUserBranchesFilter(currentData);

    getData(`/comprobantes/origen/auth-user-suc/4/${sucs}`, setComprobantes); 
    getData(`/sucursales/in-query/${sucs}`, setSucursalesConsulta); 
    setIsLoading(false);
  }, [userSucData]);

  useEffect(() => {
    setIsLoading(true);
    getDataIx0(`/sucursales/${localStorage.getItem("sucursal")}`, setUserSucData);
  }, []);

  useEffect(() => {
    if (userSucData) {
      loadData(userSucData);
    }
  }, [userSucData, loadData]);

  const anularComprobante= async(comprobante) => {
    setComprobanteAAnular(comprobante)
    setShowConfirmacion({
      open: true,
      color: "#ed710b",
      borderColor: "#ed710b",
      icon: <WarningAmberIcon sx={{ fontSize: 40 }} />,
      title: "ANULAR FACTURA",
      subtitle: (
        <>
        <Typography variant="subtitle1" color="initial">
          Se hará una <b>nota de crédito</b> por el total de la factura.
        </Typography>
        </>
      ),
      confirmText: "Presione 'confirmar' para emitir el comprobante.",
      btnText: "Confirmar",
    });
  }

  const enviarArca = async() => {
    const response = await fetch(`${UrlApi}/comprobantes/emitir_nc?envasado=${comprobanteAAnular.envasado}&origen=${4}&usuario=${localStorage.getItem("user")}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_factura: comprobanteAAnular.id_factura
        }),
    });
    if(response.ok){
      setNotify({
        open:true,
        severity:"success",
        mensaje:"Comprobante anulado con éxito!",
      })
      loadData(userSucData)
    }else{
      const json = await response.json()
      const errorMsg = await json.message || "Error en nota de crédito.";
      setNotify({
        open:true,
        severity:"error",
        mensaje:errorMsg,
      })
    }
  }

  useEffect(() => {
    const cleanup = loadData(userSucData)
    return cleanup
  }, [loadData])

  return (
    <>
      <Navbar />
      <ListadoComprobantesWeb
        comprobantes={comprobantes}
        isLoading={isLoading}
        isError={isError}
        onRefresh={loadData}
        anularComprobante={anularComprobante}
        sucursalesConsulta={sucursalesConsulta}
      />
      {setShowConfirmacion && (
        <ConfirmDialog 
          open={showConfirmacion.open} 
          setOpen={(open) => {
            loadData(userSucData);
            setShowConfirmacion({ open: open })
          }}
          icon={showConfirmacion.icon} 
          color={showConfirmacion.color} 
          borderColor={showConfirmacion.borderColor} 
          title={showConfirmacion.title} 
          subtitle={showConfirmacion.subtitle} 
          confirmText={showConfirmacion.confirmText} 
          btnText={showConfirmacion.btnText} 
          guardar={enviarArca} 
          notify={notify} 
          setNotify={setNotify} 
        />
      )}
    </>
  )
}

export default App
